import { QueryClient, QueryClientProvider } from "react-query";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes as RoutesRoot,
  useLocation,
} from "react-router-dom";

import ComingSoon from "./components/ComingSoon/ComingSoon";
import Dashboard from "./pages/Dashboard/Dashboard";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js"; // Import i18n configuration
import Login from "./pages/Login/Login";
import GlobalLogin from "./pages/Login/GlobalLogin";
import OfferRoom from "./pages/OfferRoom/OfferRoom";
import Users from "./pages/Users/Users";

import { ROUTES } from "./routes/Routes";

import ProtectedRoute from "./routes/ProtectedRoute";

import { useAuthState } from "react-firebase-hooks/auth";
import DpcModal from "./components/Dpc/DpcModal/DpcModal";
import ProductModal from "./components/Product/ProductModal/ProductModal";
import { Loading } from "./components";
import { ToastProvider } from "./context";
import { auth } from "./firebase";
import { Layout } from "./layout/Layout";
import Analytics from "./pages/Analytics/Analytics";
import Dpc from "./pages/DPC/Dpc";
import Products from "./pages/Products/Products"
import Settings from "./pages/Settings/Settings";
import ServiceTemplates from "./pages/Settings/ServiceTemplates";
import ContactFormSettings from "./pages/Settings/ContactFormSettings";
import AccessDenied from "./pages/Error/AccessDenied";
import ProductImport from "./pages/Products/Import/ProductImport";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function Routes() {
  const location = useLocation();
  i18n.changeLanguage("en");

  const previousLocation = location.state?.previousLocation;

  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <RoutesRoot location={previousLocation || location}>
        {/* Public Routes - No Layout */}
        <Route
          path="/"
          element={user ? <Navigate to="/dashboard" /> : <GlobalLogin />}
        />
        <Route
          path="/:partnerId/login"
          element={user ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path={ROUTES.LOGIN}
          element={user ? <Navigate to="/dashboard" /> : <GlobalLogin />}
        />
        <Route path={ROUTES.ACCESS_DENIED} element={<AccessDenied />} />

        {/* Protected Routes - With Layout */}
        <Route element={<Layout />}>
          <Route
            path={ROUTES.DASHBOARD}
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.OFFER_ROOM}
            element={
              <ProtectedRoute>
                <OfferRoom />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.USERS}
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ANALYTICS}
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.SETTINGS}
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.SERVICE_TEMPLATES}
            element={
              <ProtectedRoute>
                <ServiceTemplates />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.CONTACT_FORM_SETTINGS}
            element={
              <ProtectedRoute>
                <ContactFormSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.DPC}
            element={
              <ProtectedRoute>
                <Dpc />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PRODUCTS}
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PRODUCT_IMPORT}
            element={
              <ProtectedRoute>
                <ProductImport />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<ComingSoon />} />
        </Route>
      </RoutesRoot>
      {previousLocation && (
        <RoutesRoot>
          <Route path="/dpc/:id" element={<DpcModal />} />
        </RoutesRoot>
      )}
      {previousLocation && (
        <RoutesRoot>
          <Route path="/product/:id" element={<ProductModal />} />
        </RoutesRoot>
      )}

    </>
  );
}
function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <Router basename={ROUTES.HOME}>
            <Routes />
          </Router>
        </ToastProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App;
